/**
 * RoleTable - listado de roles de la plataforma.
 *
 * Sigue el patron de UsersTable/AccountsTable: `modern-table striped-table` y un
 * ActionsMenu por fila. Los roles de sistema (admin, super) no exponen acciones
 * porque su semantica esta en el codigo; se distinguen con el candado en vez de
 * dejar botones que el API iba a rechazar.
 */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCode, faLock, faShieldHalved } from '@fortawesome/free-solid-svg-icons';
import { ActionsMenu } from '../ActionsMenu';
import { countOn } from './roleMatrix';

export function RoleTable({ roles, catalog, totalActions, canManage, onEdit, onDelete }) {
    if (roles.length === 0) {
        return (
            <div className="text-center py-5 text-white-50">
                <h6 className="m-0 opacity-50">No hay roles configurados</h6>
            </div>
        );
    }

    return (
        <div className="modern-table-container">
            <table className="modern-table striped-table">
                <thead>
                    <tr>
                        <th>Rol</th>
                        <th>Tipo</th>
                        <th>Permisos</th>
                        {canManage && <th className="text-end">Acciones</th>}
                    </tr>
                </thead>
                <tbody>
                    {roles.map((r) => {
                        const on = countOn(r.modules, catalog);
                        return (
                            <tr key={r.code}>
                                <td>
                                    <div className="d-flex align-items-center gap-2">
                                        {!r.editable && (
                                            <FontAwesomeIcon icon={faLock} className="text-warning" title="Rol del sistema" />
                                        )}
                                        <div>
                                            <div className="fw-bold text-white">{r.name}</div>
                                            <div className="text-white-50" style={{ fontSize: '0.75rem' }}>
                                                <FontAwesomeIcon icon={faCode} className="me-1" />
                                                {r.code}
                                            </div>
                                        </div>
                                    </div>
                                    {r.description && (
                                        <div className="text-white-50" style={{ fontSize: '0.8rem' }}>
                                            {r.description}
                                        </div>
                                    )}
                                </td>
                                <td className="short">
                                    {r.wildcard ? (
                                        <span className="badge-status status-processing-up">
                                            <FontAwesomeIcon icon={faShieldHalved} className="me-1" />
                                            Acceso total
                                        </span>
                                    ) : (
                                        <span className="badge-status status-disabled">Personalizado</span>
                                    )}
                                </td>
                                <td className="short text-white-50">
                                    {r.wildcard ? 'Todos' : `${on}/${totalActions}`}
                                </td>
                                {canManage && (
                                    <td>
                                        {r.editable ? (
                                            <div className="d-flex justify-content-end">
                                                <ActionsMenu
                                                    items={[
                                                        { label: 'Editar', onClick: () => onEdit(r) },
                                                        { label: 'Eliminar', danger: true, onClick: () => onDelete(r) },
                                                    ]}
                                                    title={`Acciones del rol ${r.name}`}
                                                />
                                            </div>
                                        ) : (
                                            <span className="text-white-50" title="Los roles del sistema no se editan">
                                                <FontAwesomeIcon icon={faLock} />
                                            </span>
                                        )}
                                    </td>
                                )}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

export default RoleTable;
